import axios from 'axios';

import { getAdminIdToken, hasAdminRole } from '@/api/admin-access';
import { Constants } from '@/constants';
import { UserStore } from '@/stores';

export type CreditAccountType = 'user' | 'brand' | 'venue';
export interface CreditBalance {
  available: number;
  reserved: number;
  spendable: number;
}

const headers = async () => {
  if (!hasAdminRole(UserStore.getRawState().access)) {
    throw new Error('Only administrators can manage AI credits.');
  }
  return { Authorization: `Bearer ${await getAdminIdToken()}` };
};

const accountUrl = (type: CreditAccountType, id: number) => {
  if (!Number.isSafeInteger(id) || id <= 0) throw new Error('Invalid account.');
  return `${Constants.apiPath}/ai-credits/${type}/${id}`;
};

export const getAiCredits = async (type: CreditAccountType, id: number) =>
  (
    await axios.get<CreditBalance>(accountUrl(type, id), {
      headers: await headers(),
    })
  ).data;

export const addAiCredits = async (
  type: CreditAccountType,
  id: number,
  amount: number,
  reason: string,
  requestId: string
) => {
  if (!Number.isSafeInteger(amount) || amount <= 0 || amount > 1000000) {
    throw new Error('Enter a whole number between 1 and 1,000,000.');
  }
  if (!reason.trim() || reason.trim().length > 300)
    throw new Error('Enter a reason (up to 300 characters).');
  return (
    await axios.post<CreditBalance>(
      accountUrl(type, id),
      {
        amount,
        reason: reason.trim(),
        requestId,
      },
      { headers: await headers() }
    )
  ).data;
};
